import PropTypes from 'prop-types';
import { Slider } from '@material-ui/core';
import { memo } from 'react';
import useStyles from './styles';

const TwSlider = ({
  value,
  onChange,
  onChangeCommitted,
  formatSliderValue,
  min,
  max,
  valueLabelDisplay,
  step,
}) => {
  const classes = useStyles();

  return (
    <Slider
      value={value}
      onChange={onChange}
      onChangeCommitted={onChangeCommitted}
      valueLabelFormat={formatSliderValue}
      valueLabelDisplay={valueLabelDisplay}
      aria-labelledby="range-slider"
      classes={classes}
      min={min}
      max={max}
      step={step}
      // ValueLabelComponent={(obj) => (
      //   <ValueLabelComponent
      //     value={formatSliderValue
      //       ? formatSliderValue(obj.value) : obj.value}
      //     open={obj.open}
      //   >
      //     {obj.children}
      //   </ValueLabelComponent>
      // )}
    />
  );
};

TwSlider.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeCommitted: PropTypes.func.isRequired,
  formatSliderValue: PropTypes.func,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  valueLabelDisplay: PropTypes.string,
  step: PropTypes.number,
};

TwSlider.defaultProps = {
  formatSliderValue: undefined,
  // Possible values: on, off, auto
  valueLabelDisplay: 'off',
  step: undefined,
};

export default memo(TwSlider);
